import React from 'react';
import { hydrate, render } from 'react-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';

import './styles/vendors/react-select/react-select.css';
import 'ladda/dist/ladda-themeless.min.css';
import './styles/style.css';

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  hydrate(<App />, rootElement);
} else {
  render(<App />, rootElement);
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
